module.exports = __webpack_public_path__ + "img/upload-add.b03cef1f.svg";